import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { authHeader } from "../../common/apis/authHeader";
import axiosBaseURL from "../../common/apis/axiosBaseURL";
import HandleError from "../../common/apis/HandleError";
import { apiVersion } from "../../common/apis/apiVersion";

export const FaqCategoryAsyncAction = createAsyncThunk(
  "match/FaqCategoryAsyncAction",
  async () => {
    try {
      const response = await axiosBaseURL.get("/app/"+apiVersion.v1+"/cms/category_list", {
        headers: authHeader(true),
      });
      return response.data;
    } catch (error) {
      HandleError(error.response.data);
      return error.response.data;
    }
  }
);

export const FaqListAsyncAction = createAsyncThunk(
  "match/FaqListAsyncAction",
  async (data) => {
    try {
      const response = await axiosBaseURL.post("/app/"+apiVersion.v1+"/cms/faq_view", data, {
        headers: authHeader(true),
      });
      return response.data;
    } catch (error) {
      HandleError(error.response.data);
      return error.response.data;
    }
  }
);

export const CmsCategoryAsyncAction = createAsyncThunk(
  "match/CmsCategoryAsyncAction",
  async (data) => {
    try {
      const response = await axiosBaseURL.post("/app/"+apiVersion.v1+"/cms/list", data, {
        headers: authHeader(true),
      });
      return response.data;
    } catch (error) {
      HandleError(error.response.data);
      return error.response.data;
    }
  }
);

const initialState = {
  faq_cat_list: {},
  faq_list: {},
};

const cmsSlice = createSlice({
  name: "cms",
  initialState,
  reducers: {
    ResetCategroyList: (state) => {
      state.transaction_history = {};
    },
    ResetFAQList: (state) => {
      state.faq_list = {};
    },
  },
  extraReducers: {
    [FaqCategoryAsyncAction.pending]: (state) => {
      return { ...state, loading: true };
    },
    [FaqCategoryAsyncAction.fulfilled]: (state, { payload }) => {
      return { ...state, faq_cat_list: payload, loading: false };
    },
    [FaqCategoryAsyncAction.rejected]: (state) => {
      return { ...state, loading: false };
    },
    [FaqListAsyncAction.pending]: (state) => {
      return { ...state, loading: true };
    },
    [FaqListAsyncAction.fulfilled]: (state, { payload }) => {
      return { ...state, faq_list: payload, loading: false };
    },
    [FaqListAsyncAction.rejected]: (state) => {
      return { ...state, loading: false };
    },
    [CmsCategoryAsyncAction.pending]: (state) => {
      return { ...state, loading: true };
    },
    [CmsCategoryAsyncAction.fulfilled]: (state, { payload }) => {
      return { ...state, cms_list: payload, loading: false };
    },
    [CmsCategoryAsyncAction.rejected]: (state) => {
      return { ...state, loading: false };
    },
  },
});

export const { ResetCategroyList, ResetFAQList } = cmsSlice.actions;
export const getCategroyListData = (state) => state.cms.faq_cat_list;
export const getFAQListData = (state) => state.cms.faq_list;
export const getCMSListData = (state) => state.cms.cms_list;
export default cmsSlice.reducer;
